import React, { Component } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';
import moment from 'moment-timezone';
import brandLogo from '../../images/brand-logo-inverse-light.png';

let cancelToken;
let state;
let tokenSession;

class RoomCandelationReservation extends Component {

    getInitState = () => {
        return {
            password: "",
            reppasswords: "",
            isNewDate: false
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {

    }

    CancelacionSala  = (params) => {
        this.props.post(
            "/cancelReservation",
            params,
            (response) => this.didUpdateStatus(response),
            (error) => this.handleErrorResponsegetUpdateReservation(error),
            cancelToken
        );
    }

    didUpdateStatus = (response) => {
        alert('LA RESERVACION FUE CANCELADA');
        window.location.reload();
    }

    handleErrorResponsegetUpdateReservation = (error) => {
        console.error(error);
    }

    confirmarCancelacionSala = (event) => {
        this.CancelacionSala({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            id: this.props.reservation.id
        });
    }

    render() {
        const reservation = this.props.reservation
        const endDate = moment(reservation.end_date, 'YYYY-MM-DD HH:mm:ss');
        const startDate = moment(reservation.start_date, 'YYYY-MM-DD HH:mm:ss');
        const { t } = this.props;
        return (
            <div>
                <button
                    className="hidden"
                    data-target="#modalCandelacionSuccess"
                    data-toggle="modal"
                    id="btnSuccessCancelacion"
                    type="button">
                </button>
                <div className="modal fade" id="modalCandelacionSuccess" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header COVID-HEADER">
                                <button type="button" className="close btn-primary" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;</span></button>
                                <div className="navbar-header">
                                    <div className="navbar-brand">
                                        <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body">
                                <h3>{t('dashboard.history.cancel_reservation')}</h3>
                                <div className="card-panel-body">
                                    <div className="form-group card-panel panel panel-default card center-block" style={{ display: 'block', padding: '10px' }}>
                                        <h5 className="ioscentro">{reservation.center_name}</h5>
                                        <h5 className="iossala">{reservation.name}</h5>
                                        <div className="panel-description-text">
                                            {reservation.description}
                                        </div>
                                        <div className="contenedor">
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            &ensp;
                                            {startDate.format('ll')}
                                        </div>
                                        <div className="contenedor">
                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                            &ensp;
                                            {startDate.format('HH:mm')} - {endDate.format('HH:mm')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer panel-body-bottom">
                                <button
                                    className="btn btn-block btn-primary btn-search-history btn-singup"
                                    data-dismiss="modal"
                                    onClick={this.confirmarCancelacionSala}
                                    type="button">
                                    {t('dashboard.history.cancel_reservation')}
                                </button>
                                <button
                                    className="btn btn-block btn-default btn-secondary"
                                    data-dismiss="modal"
                                    type="button">
                                    {t('dashboard.contact.btn_success')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(RoomCandelationReservation);


// WEBPACK FOOTER //
// ./src/dashboard/history/RoomCancelationReservation.js